import React from 'react';
import { filter, orderBy } from 'lodash';
import enhance from './CompanyPaymentSettings.enhancer';
import Paper from '@material-ui/core/Paper';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { PayPalButton } from 'react-paypal-button-v2';
import TextField from '@material-ui/core/TextField';
import { balanceChangeType } from '../../../../constants';
import CircularProgress from '@material-ui/core/CircularProgress';

class AddCompanyBalance extends React.Component {
  constructor() {
    super();

    const initialState = {
      balanceToAdd: '',
      minDeposit: 100,
      maxDeposit: 50000,
      invalidAmountAttempt: false,
      depositAmountError: false,
      isAddingBalance: false
    };

    this.state = {
      ...initialState
    };
  }

  depositAmountChangeHandler(e) {
    this.setState({
      balanceToAdd: e.target.value
    });

    if (
      e.target.value >= this.state.minDeposit &&
      e.target.value <= this.state.maxDeposit
    ) {
      this.setState({
        depositAmountError: false
      });
    } else {
      this.setState({
        depositAmountError: true
      });
    }
  }

  onUpdateComplete = () => {
    this.setState({
      isAddingBalance: false
    });

    this.props.onCloseDialog();
  };

  render() {
    const {
      balanceToAdd,
      minDeposit,
      maxDeposit,
      isAddingBalance
    } = this.state;
    const { classes, isOpen, onCloseDialog } = this.props;

    return (
      <React.Fragment>
        <Dialog
          id="add-company-funds-dialog"
          open={isOpen}
          onClose={onCloseDialog}
          disableAutoFocus={true}
          onBackdropClick={onCloseDialog}
          PaperProps={{
            style: {
              minWidth: '400px',
              maxWidth: '400px',
              height: '500px',
              padding: '20px'
            }
          }}
        >
          <Typography
            variant="h4"
            align="center"
            className={classes.addFundsText}
          >
            Add Funds
          </Typography>
          <Typography gutterBottom className="info-helper-text">
            Deposit Amount
          </Typography>
          <TextField
            id="depositAmount"
            name="depositAmount"
            type="number"
            fullWidth
            onChange={this.depositAmountChangeHandler.bind(this)}
            // className={classes.select}
            variant="outlined"
            value={balanceToAdd}
            className={classes.depositAmountInput}
            error={this.state.depositAmountError ? true : false}
            helperText={
              this.state.depositAmountError
                ? 'deposit must be between $100 - $50,000'
                : ''
            }
          />
          <Typography className="info-helper-text" align="center">
            Please secure funds using one of the following methods:
          </Typography>
          <PayPalButton
            amount={balanceToAdd}
            createOrder={(data, actions) => {
              if (balanceToAdd >= minDeposit && balanceToAdd <= maxDeposit) {
                this.setState({
                  invalidAmountAttempt: false,
                  isAddingBalance: true
                });
                return actions.order.create({
                  purchase_units: [
                    {
                      amount: {
                        currency_code: 'USD',
                        value: balanceToAdd
                      }
                    }
                  ]
                });
              } else {
                alert('invalid deposit amount');
              }
            }}
            onSuccess={(details, data) => {
              const depositDetails = {
                ...details,
                ...data,
                type: balanceChangeType.DEPOSIT
              };

              this.props.updateCompanyBalance(
                depositDetails,
                this.onUpdateComplete
              );
            }}
            catchError={err => {
              console.log(err);
              this.setState({
                isAddingBalance: false
              });
              alert('error');
            }}
            options={{
              clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID_BUSINESS
            }}
          />
          {isAddingBalance && (
            <div className={classes.loadingOverlay}>
              <CircularProgress className={classes.loadingSpinner} />
            </div>
          )}
        </Dialog>
      </React.Fragment>
    );
  }
}

export default enhance(AddCompanyBalance);



// WEBPACK FOOTER //
// ./src/components/company/settings/payments/AddCompanyBalance.js